import type { Organization } from '~publish/legacy/organizations/types'
import type { Profile } from '~publish/legacy/profile-sidebar/types'

type ProfileOrganizationFields = Pick<Profile, 'id' | 'organizationId'>

export const filterProfilesByOrg = <T extends ProfileOrganizationFields>(
  profiles: T[],
  organization: Pick<Organization, 'id'> | null | undefined,
): T[] => {
  if (!organization) {
    return profiles
  }
  return profiles?.filter(
    (profile) => profile.organizationId === organization.id,
  )
}
